import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const RouteWatcher = () => {
  const location = useLocation();

  useEffect(() => {
    const currentPath = location.pathname;

    const isAllRoute =
      currentPath.startsWith("/app/") &&
      currentPath.toLowerCase().includes("/all");

    const isTeamRoute =
      currentPath.startsWith("/app/") && currentPath.includes("/TeamTickets");

    const isMyRoute =
      currentPath.startsWith("/app/") && currentPath.includes("/MyWorkspace");

    const isCredtedRoute =
      currentPath.startsWith("/app/") && currentPath.includes("/Created");

    if (!isAllRoute) {
      localStorage.removeItem("AllTableSearch");
    }

    if (!isTeamRoute) {
      localStorage.removeItem("TeamTableSearch");
    }

    if (!isMyRoute) {
      localStorage.removeItem("MyWorkspaceTableSearch");
    }
    if (!isCredtedRoute) {
      localStorage.removeItem("CreateTableSearch");
    }
  }, [location.pathname]);

  return null;
};

export default RouteWatcher;
